import { defineComponent as _defineComponent } from 'vue';
import { BListGroup } from "bootstrap-vue";
import ConfigurationTestItem from "./ConfigurationTestItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfigurationTestSummary',
    props: {
        testResults: null
    },
    setup(__props) {
        return { __sfc: true, BListGroup, ConfigurationTestItem };
    }
});
